import { useState } from 'react'

import {
  UPDATED_SYSTEM_NAMES_NEW,
  UPDATED_SYSTEM_NAMES_ACTIVE,
  SYSTEM_ORDER,
  SYSTEM_CODE
} from '../constants'

const useAvailableSystems = (isNewTab: boolean) => {
  const [availableSystems, setAvailableSystems] = useState<Record<string, string>>({})

  const updatedSystemNames = isNewTab ? UPDATED_SYSTEM_NAMES_NEW : UPDATED_SYSTEM_NAMES_ACTIVE

  const loadAvailableSystems = () => {
    fetch('https://elama.ru/agency-api/commission/calculator/system/list')
      .then(response => response.json())
      .then(data => {
        const sortedSystems: Record<string, string> = {}
        SYSTEM_ORDER.forEach(key => {
          if (!isNewTab && key === SYSTEM_CODE.YANDEX_NETWORK) {
            return
          }

          sortedSystems[key] = data[key]
        })
        const updateDataValues = Object.fromEntries(
          Object.entries(sortedSystems).map(([key, value]) => {
            if (updatedSystemNames[key]) {
              return [key, updatedSystemNames[key]]
            }
            return [key, value]
          })
        )
        setAvailableSystems(updateDataValues)
      })
  }

  return { availableSystems, loadAvailableSystems }
}

export default useAvailableSystems
